export default "//cdn.scentbird.com/assets/frontbird-site/images/card-front@2x_e4e86c.png";